import type { CreditAppSearchState } from '../reducers/creditAppSearchReducer';

export const getState = (state: any): CreditAppSearchState => state.creditAppSearch;

export const getSlideOutOpen = (state: any): boolean => getState(state).slideOutOpen;

export const getShowSaveReminder = (state: any): boolean => getState(state)?.showSaveReminder || false;
